import { type PropsWithChildren, type ReactNode, useState } from "react";

import { AnimatePresence, motion } from "framer-motion";

import { Badge } from "@components/v2";
import { renderChevronAnimation } from "@shared/selects/utils";

interface Props {
  title: string;
  icon?: ReactNode;
  isExpandedByDefault?: boolean;
  rightSideContent?: (isExpanded: boolean) => ReactNode;
}

export function Accordion({
  title,
  icon,
  isExpandedByDefault,
  rightSideContent,
  children,
}: PropsWithChildren<Props>) {
  const [isExpanded, setExpanded] = useState(isExpandedByDefault || false);

  return (
    <div className="border-b border-v2-tertiary">
      <div
        className="text-xs font-semibold flex items-center gap-2 cursor-pointer h-10"
        onClick={() => setExpanded(!isExpanded)}
      >
        {renderChevronAnimation(isExpanded)}
        <span className="flex-1 flex items-center gap-2">
          {icon}
          {title}
        </span>
        {rightSideContent?.(isExpanded)}
      </div>
      <AnimatePresence initial={false}>
        {isExpanded && (
          <motion.div
            initial={{ height: 0 }}
            animate={{ height: "auto" }}
            exit={{ height: 0 }}
            transition={{ ease: "easeOut", duration: 0.2 }}
            className="overflow-hidden"
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
